import script from "./AllList.vue?vue&type=script&setup=true&lang=js"
export * from "./AllList.vue?vue&type=script&setup=true&lang=js"

import "./AllList.vue?vue&type=style&index=0&id=67cc1242&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67cc1242"]])

export default __exports__